/**
 * GTM (Google Tag Manager) Tracking Utility
 * 
 * This utility provides a reusable function to track events via Google Tag Manager's dataLayer.
 */

/**
 * Track an event in Google Tag Manager
 * @param {string} eventName - The name of the event to track (typically matching the element ID)
 * @param {object} eventData - Additional data to send with the event (optional)
 */
export const trackGTMEvent = (eventName, eventData = {}) => {
    console.log(`GTM Event Tracked: ${eventName}`, eventData);
    if (window.dataLayer) {
        window.dataLayer.push({
            event: eventName,
            ...eventData
        });
    }
};
